import { PixelService } from './service';

/**
 * Mock Pixel Service for development and testing
 */
export class PixelServiceMock extends PixelService {
  constructor() {
    super();
  }

  async trackConversion(_eventName: string, _params?: Record<string, unknown>): Promise<void> {
    // Mock implementation - no-op
  }

  async trackEvent(_eventName: string, _params?: Record<string, unknown>): Promise<void> {
    // Mock implementation - no-op
  }

  async pageView(_path: string): Promise<void> {
    // Mock implementation - no-op
  }
}
